import * as yup from "yup";

export const formularioVam = yup.array().of(
    yup.object().shape({
        a1: yup.string().required("Favor seleccione"),
        a2: yup.string().required("Favor seleccione"),
        diagnostico: yup.string().required("Ingrese este campo"),
        celularT: yup.string().required("Ingrese este campo"),
        escanea: yup.string().required("Ingrese este campo"),
    })
);

export const formularioCredito = yup.array().of(
    yup.object().shape({
        a1: yup.string().required("Favor seleccione"),
        a2: yup.string().required("Favor seleccione"),
        diagnostico: yup.string().required("Ingrese este campo"),
        celularT: yup.string().required("Ingrese este campo"),
        centroMedico: yup.string().required("Ingrese este campo"),
        escanea: yup.string().required("Ingrese este campo"),
    })
);
